import { Component, OnInit } from '@angular/core';
import {DataOperationService} from '../../utils/data-services/data-operation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DataConcessionService} from '../../utils/data-services/dataConcession.service';

@Component({
  selector: 'app-modification-operation',
  templateUrl: './modification-operation.component.html',
  styleUrls: ['./modification-operation.component.scss']
})
export class ModificationOperationComponent implements OnInit {

  concessionName: any;
  idOperation: any;
  operation = {
    sofNet_id: '',
    bmw_id: null,
    categorie_id: null,
    concession_id: null,
    nom: '',
    prix: null,
    vt: null,
    requiredStandartRangeService: false,
    dynamicTest: null,
    actif: false,
    ordre: null,
    blocked: false,
    aideAdditionnel: false,
    commentaireAdditionnel: null,
    type_id: null,
    attente_autorise: false,
    minimum_delay: null,
    id: null
  };
  categorieArray = [];
  typeArray = [];
  constructor( private dataService: DataOperationService, private route: Router, private activeRoute: ActivatedRoute, private dataServiceConcession: DataConcessionService ) { }

  ngOnInit() {
    this.idOperation = Number(this.activeRoute.snapshot.paramMap.get('idOperation'));
    this.getAllCategorie();
    this.getAllType();
    this.getOperationById();
  }
  updateOperation() {
    this.dataService.updateOperation([this.operation]).subscribe(result => {
      this.route.navigate(['../gestion-operation/' + this.operation.concession_id]);
    });
  }
  onCancelClik() {
    this.route.navigate(['../gestion-operation/' + this.operation.concession_id]);
  }
  onChangeCheckbox(type) {
    this.operation[type] = !this.operation[type];
  }
  getAllCategorie() {
    this.dataService.getAllCategorie().subscribe(result => {
      this.categorieArray = result;
    });
  }
  getOperationById() {
    this.dataService.getOperationById(this.idOperation).subscribe(result => {
      this.operation = result;
    });
  }

  getAllType() {
    this.dataService.getAllType().subscribe(result => {
      this.typeArray = result;
    });
  }

}
